module.exports = __webpack_public_path__ + "img/vote_illustration1.364646a1.png";